import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react'
import { getApi, postApi, putApi } from '../../../Services/apiService';
import { DatePicker, Modal } from 'antd';
import dayjs from 'dayjs';
import {fetchTypeFilter,handleImportClickFile, isEmptyObject, TableFooter, checkAddPermission, fetchProductGroupVarietiesFilterData, fetchCategoryDataFilterV2, fetchOriginDataFilterV2, fetchBrandFilterV2, fetchPicImportDataFilterV2, fetchPicSalesDataFilterV2, fetchSuppliers, fetchShippingData, getCanonicalTimezone } from '../../../Utils/helper';
import { format, addDays, eachDayOfInterval } from 'date-fns';
import { toast } from 'react-toastify';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MultiSelectDropdown, { DependentMultiSelectDropdown } from '../../../Utils/multiSelectDropdown';
import Import from '../../../Utils/import';
import GenerateTable from './generateTable';
import AddEditReserve from '../Reserve/addEditReserve';
import AddEditArrival from '../Arrival/addEditArrival';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPermissionData } from "../../../Counter/permissionData";
import {  exportPrepackInOut } from '../../../Services/importExport';

// Memoized components
const MemoizedGenerateTable = React.memo(GenerateTable);

function PrepackInout() {
   // get params using serach param
  const [searchParams, setSearchParams] = useSearchParams();

  // Extract all URL parameters for cell highlighting
  const date = searchParams.get("date");
  const cellType = searchParams.get("cell_type");
  const productIdFromUrl = searchParams.get("product_id");
  const productGroupIdFromUrl = searchParams.get("product_group_id");
  const finishedProductIdFromUrl = searchParams.get("finished_product_id");
  const rawProductIdFromUrl = searchParams.get("raw_product_id");
  const customerGroupIdFromUrl = searchParams.get("customer_group_id");
  const customerSubGroupIdFromUrl = searchParams.get("customer_sub_group_id");
  const reserveLabelFromUrl = searchParams.get("reserve_label");
  const arrivalIndexFromUrl = searchParams.get("arrival_index");
  
  const dispatch = useDispatch()
  const [highlightCellData, setHighlightCellData] = useState(null);

  // Set productIds from URL parameter and prepare cell highlight
  useEffect(() => {
    if (finishedProductIdFromUrl || productIdFromUrl || productGroupIdFromUrl) {
      // Set the product filter
      if (finishedProductIdFromUrl) {
        setProductIds([finishedProductIdFromUrl]); 
      } else if (productIdFromUrl) {
        setProductIds([productIdFromUrl]);
      }
      console.log(cellType, 'cellType');
      console.log(date, 'date');
      console.log(productIdFromUrl, 'productIdFromUrl');
      console.log(productGroupIdFromUrl, 'productGroupIdFromUrl');
      console.log(finishedProductIdFromUrl, 'finishedProductIdFromUrl');
      console.log(rawProductIdFromUrl, 'rawProductIdFromUrl');
      console.log(customerGroupIdFromUrl, 'customerGroupIdFromUrl');
      console.log(customerSubGroupIdFromUrl, 'customerSubGroupIdFromUrl');
      console.log(reserveLabelFromUrl, 'reserveLabelFromUrl');
      console.log(arrivalIndexFromUrl, 'arrivalIndexFromUrl');
      // Store cell data for highlighting
      if (date && cellType) {
        setHighlightCellData({
          date,
          cell_type: cellType,
          product_id: productIdFromUrl,
          product_group_id: productGroupIdFromUrl,
          finished_product_id: finishedProductIdFromUrl,
          raw_product_id: rawProductIdFromUrl,
          customer_group_id: customerGroupIdFromUrl,
          customer_sub_group_id: customerSubGroupIdFromUrl,
          reserve_label: reserveLabelFromUrl,
          arrival_index: arrivalIndexFromUrl,
        });
      }
      if(arrivalIndexFromUrl && arrivalIndexFromUrl>0){
        setShowAllArrivals(true);
      }

      // Clear all URL parameters after processing
      setSearchParams({}, { replace: true });
    }
  }, [finishedProductIdFromUrl, productIdFromUrl, productGroupIdFromUrl, date, cellType, rawProductIdFromUrl, customerGroupIdFromUrl, customerSubGroupIdFromUrl, reserveLabelFromUrl, arrivalIndexFromUrl, setSearchParams]);

  // Sync date range when URL date param changes (e.g. notification click while already on page)
  useEffect(() => {
    const dateFromUrl = searchParams.get('date');
    if (dateFromUrl) {
      const baseDate = dayjs(dateFromUrl);
      setDateState({
        startDate: baseDate.subtract(7, 'day').format('YYYY-MM-DD'),
        endDate: baseDate.add(1, 'month').format('YYYY-MM-DD')
      });
    }
  }, [searchParams]);
  
  const tableRef = useRef(null);
  const navigate = useNavigate()
  const { RangePicker } = DatePicker;
  const { data } = useSelector((state) => state.roleData);
  const dropdownRef = useRef(null);
  const modalRef = useRef(null)

  // const [categoryData, setCategoryData] = useState([])
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([])
  const [productGroupVarietyFilterData, setProductGroupVarietyFilterData] = useState([])
  const [selectedProductGroupVarietyIds, setSelectedProductGroupVarietyIds] = useState([])
  const [selectedOriginIds, setSelectedOriginIds] = useState([])

  const [originData, setOriginData] = useState([])


  const [picSalesData, setPicSalesData] = useState([])
  const [picImportData, setPicImportData] = useState([])
  const [productData, setProductData] = useState([])
  const [totalProduct, setTotalProduct] = useState(0)
  const [selectedPicImport, setSelectedPicImport] = useState([])
  const [selectedPicSales, setSelectedPicSales] = useState([])

  const [brandData, setBrandData] = useState([])
  const [typesData, setTypesData] = useState([])
  const [selectedBrandName, setSelectedBrandName] = useState([])
  const [selectedType, setSelectedType] = useState([])
  const [dateState, setDateState] = useState(() => {
    const dateFromUrl = searchParams.get('date');
    if (dateFromUrl) {
      const baseDate = dayjs(dateFromUrl);
      return {
        startDate: baseDate.subtract(7, 'day').format('YYYY-MM-DD'),
        endDate: baseDate.add(1, 'month').format('YYYY-MM-DD')
      };
    }
    return {
      startDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
      endDate: dayjs().add(1, 'month').format('YYYY-MM-DD')
    };
  });

  const [inoutData, setInoutData] = useState({})
  const [arrivalModalShow, setArrivalModalShow] = useState(false)
  const [arrivalModalData, setArrivalModalData] = useState({})
  const [productIds, setProductIds] = useState([])
  const [excludedProductIds, setExcludedProductIds] = useState([])
  const [selectedProductsData, setSelectedProductsData] = useState([])
  const [perPageSearch, setPerPageSearch] = useState(1);
  // const [reserveUpdateData, setReserveUpdateData] = useState([])
  const [inputValues, setInputValues] = useState({})
  const [convertOutInputs, setConvertOutInputs] = useState({})
  const [modalReserve, setModalReserve] = useState(false)
  const [reserveModalUpdateData, setReserveModalUpdateData] = useState([])
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [quantityValue, setQuantityValue] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [searchInputValue, setSearchInputValue] = useState('');
  const [isEditing, setIsEditing] = useState('');
  const [updateValue, setUpdateValue] = useState(null);
  const [updateId, setUpdateId] = useState(null);
  const [updateDate, setUpdateDate] = useState(null);
  const [updateProduct, setUpdateProduct] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemPerPage] = useState(150);
  const [allDatess, setAllDates] = useState([]);
  const [reserveModalError, setReserveModalError] = useState('');
  const [totalPage, setTotalPages] = useState(0);
  const [tableLoader, setTableLoader] = useState(false);
  const [showGroupData, setshowGroupData] = useState(null);
  const [selectedGroupProducts, setSelectedGroupProducts] = useState([]);
  const [toastMessage, setToastMessage] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importErrors, setImportErrors] = useState({
    file: '',
    general: ''
  });
  const [showAllArrivals, setShowAllArrivals] = useState(false);
  // Add state for arrival modal selection and quantity
  const [selectedArrivalProductId, setSelectedArrivalProductId] = useState(null);
  const [selectedArrivalProductData, setSelectedArrivalProductData] = useState({});
  const [arrivalQuantityMap, setArrivalQuantityMap] = useState({});
  const [arrivalModalError, setArrivalModalError] = useState('');
  const [arrivalModalLoading, setArrivalModalLoading] = useState(false);
  const [productSearchInput, setProductSearchInput] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [productLabelModal, setProductLabelModal] = useState(false);
  const [addColumnModal, setAddColumnModal] = useState(false);
  const [labelData, setLabelData] = useState([]);
  const [subGroup, setSubGroup] = useState('');
  const [subGroupName, setSubGroupName] = useState('');
  const [groupName, setGroupName] = useState('');
  const [productName, setProductName] = useState('');
  const [labelDate, setLabelDate] = useState(null);
  const [groupProductIds, setGroupProductIds] = useState(null);
  const productSearchRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [productGroupLabelModal, setProductGroupLabelModal] = useState(false);
  // const [modalType, setModalType] = useState('');
  const [selectAll, setSelectAll] = useState(false);
  const [productLoader, setProductLoader] = useState(false);
  const tableContainerRef = useRef(null);
  const [currentPinkSectionPage, setCurrentPinkSectionPage] = useState(1);
  const [totalPinkPages, setTotalPinkPages] = useState(0);
  const [pinkSectionLoading, setPinkSectionLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [expandProductRows, setExpandProductRows] = useState(false);
  const [labels, setLabels] = useState([]);
  const [labelCustomerGroups, setLabelCustomerGroups] = useState([]);
  const [customerSubGroups, setCustomerSubGroups] = useState([]);
  const handleScroll = (e) => {
    setScrolled(e.target.scrollTop > 0);
  };
  const groupRef = useRef(null);
  const firstRadioRefProductLabel = useRef(null);
  const firstRadioArrivalRef = useRef(null);
  const quatityRef = useRef(null);

  const [individualGroupOpen, setIndividualGroupOpen] = useState(false)
  const [isIndividual, setIsIndividual] = useState(false);
  const [selectedCellsForSum, setSelectedCellsForSum] = useState({});
  const [modalConvertOut, setModalConvertOut] = useState(false);

  // Inline Add Arrival modal state
  const [inlineArrivalModal, setInlineArrivalModal] = useState(false);
  const [inlineArrivalProductId, setInlineArrivalProductId] = useState(null);
  const [inlineArrivalRefreshIds, setInlineArrivalRefreshIds] = useState(null);
  const [arrivalSuppliers, setArrivalSuppliers] = useState([]);
  const [arrivalShippingMethods, setArrivalShippingMethods] = useState([]);
  const [arrivalProductList, setArrivalProductList] = useState([]);
  const [arrivalSelectedShowProducts, setArrivalSelectedShowProducts] = useState([]);
  const [arrivalFilterDatas, setArrivalFilterDatas] = useState([]);
  const [arrivalIsLoading, setArrivalIsLoading] = useState(false);
  const [arrivalSearchTerm, setArrivalSearchTerm] = useState('');
  const [arrivalFormData, setArrivalFormData] = useState({
    supplier: '', shipping_method: '', order_remark: '', container_no: '',
    atd: '', ata: '', eta: '', status: 0, arrival_id: ''
  });
  const [arrivalErrors, setArrivalErrors] = useState({
    supplier: '', shipping_method: '', order_remark: '', container_no: '',
    atd: '', ata: '', eta: '', status: ''
  });
  const [arrivalTouched, setArrivalTouched] = useState({
    supplier: false, shipping_method: false, order_remark: false, container_no: false,
    atd: false, ata: false, eta: false, status: false
  });

  // Inline Add Reserve modal state
  const [inlineReserveModal, setInlineReserveModal] = useState(false);
  const [inlineReservePrefill, setInlineReservePrefill] = useState({
    productId: null,
    productName: '',
    productCode: '',
    refreshIds: null,
    dateRange: { start: null, end: null }
  });
  const [reserveCustomerGroupData, setReserveCustomerGroupData] = useState([]);
  const [reserveCustomerSubGroupData, setReserveCustomerSubGroupData] = useState([]);

  const handleInlineAddReserve = useCallback((productId, productName, productCode, refreshIds) => {
    setInlineReservePrefill({
      productId,
      productName,
      productCode,
      refreshIds,
      dateRange: {
        start: dateState?.startDate,
        end: dateState?.endDate
      }
    });
    setInlineReserveModal(true);
  }, [dateState]);

  // Fetch customer group data for inline reserve modal
  useEffect(() => {
    const fetchCustomerGroups = async () => {
      const [groupResp, subGroupResp] = await Promise.all([
        getApi('/customer-group?per_page=999&&only_customer_groups=1'),
        getApi('/customer-sub-group?per_page=100')
      ]);
      if (groupResp?.success) setReserveCustomerGroupData(groupResp.data?.customerGroups?.data || []);
      if (subGroupResp?.success) setReserveCustomerSubGroupData(subGroupResp.data?.customerSubGroups || []);
    };
    fetchCustomerGroups();
  }, []);

  // Fetch suppliers and shipping methods for inline arrival modal
  useEffect(() => {
    fetchSuppliers('', setArrivalSuppliers);
    fetchShippingData('', setArrivalShippingMethods);
  }, []);

  const fetchNextArrivalId = async () => {
    try {
      const tz = getCanonicalTimezone();
      const resp = await getApi(`/arrival-summary?page=1&per_page=1&sort_column=arrival_id&sort_order=desc&timezone=${encodeURIComponent(tz)}`);
      if (resp?.success) {
        const sorted = [...(resp.data?.arrivalSummaries?.data || [])].sort((a, b) => Number(b.arrival_id) - Number(a.arrival_id));
        const highest = sorted[0]?.arrival_id ? Number(sorted[0].arrival_id) : 0;
        return highest + 1;
      }
    } catch (e) {
      // fall back to empty
    }
    return '';
  };

  const handleInlineAddArrival = useCallback(async (productId, productName, productCode, refreshIds) => {
    setInlineArrivalProductId(productId);
    setInlineArrivalRefreshIds(refreshIds);
    setArrivalErrors({ supplier: '', shipping_method: '', order_remark: '', container_no: '', atd: '', ata: '', eta: '', status: '' });
    setArrivalTouched({ supplier: false, shipping_method: false, order_remark: false, container_no: false, atd: false, ata: false, eta: false, status: false });
    setArrivalSelectedShowProducts([]);
    setArrivalProductList([]);
    // Fetch next arrival_id and the full product data (for correct specification etc.) in parallel
    const [nextArrivalId, productResp] = await Promise.all([
      fetchNextArrivalId(),
      productId ? getApi(`/product?per_page=50&search=${encodeURIComponent(productCode || '')}`) : Promise.resolve(null),
    ]);
    if (productId && productResp?.success) {
      const list = productResp.data?.products?.data || [];
      const match = list.find(p => p.id === productId || p.id === Number(productId));
      if (match) {
        setArrivalSelectedShowProducts([{ ...match, quantity: '', barcode: match.barcode ?? '', checked: true }]);
      }
    }
    setArrivalFormData({ supplier: '', shipping_method: '', order_remark: '', container_no: '', atd: '', ata: '', eta: '', status: 0, arrival_id: nextArrivalId });
    setInlineArrivalModal(true);
  }, []);

  const arrivalResetFormArrival = () => {
    arrivalResetForm();
  };

  const arrivalHandleProductChange = (id, field, value) => {
    setArrivalSelectedShowProducts(prev => prev.map(p => p.id === id ? { ...p, [field]: value } : p));
    setArrivalProductList(prev => prev.map(p => p.id === id ? { ...p, [field]: value } : p));
  };

  const arrivalRemoveProduct = (id) => {
    setArrivalSelectedShowProducts(prev => prev.filter(p => p.id !== id));
  };

  const arrivalToggleProductCheckbox = (id, checked) => {
    setArrivalSelectedShowProducts(prev => {
      const exists = prev.some(p => p.id === id);
      if (exists) {
        return checked ? prev.map(p => p.id === id ? { ...p, checked } : p) : prev.filter(p => p.id !== id);
      }
      if (checked) {
        const product = arrivalProductList.find(p => p.id === id);
        return product ? [...prev, { ...product, checked: true }] : prev;
      }
      return prev;
    });
  };

  const arrivalToggleAllProductsCheckbox = (checked) => {
    setArrivalSelectedShowProducts(prev =>
      prev.map(p => ({ ...p, checked }))
    );
  };

  const arrivalHandleInputChange = (e) => {
    const { name, value } = e.target;
    setArrivalFormData(prev => ({ ...prev, [name]: value }));
  };

  const arrivalHandleDateChange = (e) => {
    const { name, value } = e.target;
    setArrivalFormData(prev => ({ ...prev, [name]: value }));
  };

  const arrivalValidateField = (fieldName, value) => {
    let error = '';
    if (['supplier', 'shipping_method', 'order_remark'].includes(fieldName)) {
      if (!value || (typeof value === 'string' && !value.trim())) error = `${fieldName.replace('_', ' ')} is required`;
    }
    if (['atd', 'ata', 'eta'].includes(fieldName)) {
      if (!value) error = `${fieldName.toUpperCase()} is required`;
    }
    setArrivalErrors(prev => ({ ...prev, [fieldName]: error }));
    return !error;
  };

  const arrivalHandleBlur = (e) => {
    const { name, value } = e.target;
    setArrivalTouched(prev => ({ ...prev, [name]: true }));
    arrivalValidateField(name, value);
  };

  const arrivalValidateForm = () => {
    setArrivalTouched({ supplier: true, shipping_method: true, order_remark: true, container_no: true, eta: true, status: true });
    let isValid = true;
    ['supplier', 'shipping_method', 'container_no', 'eta', 'order_remark'].forEach(key => {
      if (!arrivalValidateField(key, arrivalFormData[key])) isValid = false;
    });
    if (arrivalSelectedShowProducts?.length === 0) {
      toast.error('Please add at least one product');
      return false;
    }
    const invalidProducts = arrivalSelectedShowProducts.filter(p => p.quantity === undefined || p.quantity === null || isNaN(p.quantity));
    if (invalidProducts.length > 0) {
      toast.error('Please fill quantity for all selected products');
      return false;
    }
    return isValid;
  };

  const arrivalResetForm = () => {
    setArrivalFormData({ supplier: '', shipping_method: '', order_remark: '', container_no: '', atd: '', ata: '', eta: '', status: 0, arrival_id: '' });
    setArrivalErrors({ supplier: '', shipping_method: '', order_remark: '', container_no: '', atd: '', ata: '', eta: '' });
    setArrivalTouched({ supplier: false, shipping_method: false, order_remark: false, container_no: false, atd: false, ata: false, eta: false });
    setArrivalSelectedShowProducts([]);
    setArrivalProductList([]);
  };




  const handleInlineAddArrivalSubmit = async () => {
    if (!arrivalValidateForm()) return;
    try {
      setArrivalIsLoading(true);
      const safeVal = (v) => (v === null || v === undefined ? '' : v);
      const payload = new FormData();
      payload.append('supplier_id', safeVal(arrivalFormData.supplier));
      payload.append('shipping_method_id', safeVal(arrivalFormData.shipping_method));
      payload.append('order_remark', safeVal(arrivalFormData.order_remark));
      payload.append('container_no', safeVal(arrivalFormData.container_no));
      payload.append('atd', safeVal(arrivalFormData.atd));
      payload.append('ata', safeVal(arrivalFormData.ata));
      payload.append('eta', safeVal(arrivalFormData.eta));
      payload.append('status', safeVal(arrivalFormData.status));
      payload.append('arrival_id', safeVal(arrivalFormData.arrival_id));
      arrivalSelectedShowProducts.forEach((product, index) => {
        payload.append(`products[${index}][id]`, safeVal(product?.id));
        payload.append(`products[${index}][quantity]`, product.quantity === '' || product.quantity === undefined || product.quantity === null ? 0 : Number(product.quantity));
        payload.append(`products[${index}][barcode]`, safeVal(product?.barcode) || 0);
      });
      const response = await postApi('/arrival-summary', payload);
      if (response?.success) {
        toast.success(response.msg || 'Arrival added successfully');
        setInlineArrivalModal(false);
        arrivalResetForm();
        // getInOutDataForReserveUpdate(inlineArrivalRefreshIds || (inlineArrivalProductId ? [inlineArrivalProductId] : null));
        getArrivalsData();
      } else {
        toast.error(response?.msg || 'Failed to add arrival');
      }
    } catch (error) {
      toast.error(error.response?.data?.msg || error.message || 'Failed to add arrival');
    } finally {
      setArrivalIsLoading(false);
    }
  };

  useEffect(() => {
    if (productGroupLabelModal && groupRef.current) {
      groupRef.current.focus();
    }
    if (productLabelModal && firstRadioRefProductLabel.current) {
      firstRadioRefProductLabel.current.focus();
    }
    if (arrivalModalShow && firstRadioArrivalRef.current) {
      firstRadioArrivalRef.current.focus();
    }
  }, [productGroupLabelModal, productLabelModal, arrivalModalShow]);

  // Click cell after table renders (for notification redirects)
  useEffect(() => {
    if (highlightCellData && inoutData && Object.keys(inoutData).length > 0) {
      // Wait for table to render
      setTimeout(() => {
        const cellSelector = `[data-cell-type="${highlightCellData.cell_type}"][data-date="${highlightCellData.date}"]` +
          (highlightCellData.product_id ? `[data-product-id="${highlightCellData.product_id}"]` : '') +
          (highlightCellData.product_group_id ? `[data-product-group-id="${highlightCellData.product_group_id}"]` : '') +
          (highlightCellData.finished_product_id ? `[data-finished-product-id="${highlightCellData.finished_product_id}"]` : '') +
          (highlightCellData.raw_product_id ? `[data-raw-product-id="${highlightCellData.raw_product_id}"]` : '') +
          (highlightCellData.customer_group_id ? `[data-customer-group-id="${highlightCellData.customer_group_id}"]` : '') +
          (highlightCellData.customer_sub_group_id ? `[data-customer-sub-group-id="${highlightCellData.customer_sub_group_id}"]` : '') +
          (highlightCellData.reserve_label ? `[data-reserve-label="${highlightCellData.reserve_label}"]` : '') +
          (highlightCellData.arrival_index ? `[data-arrival-index="${highlightCellData.arrival_index}"]` : '');
        
        const cell = document.querySelector(cellSelector);
        if (cell) {
          // Scroll to cell
          cell.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
       
    
         
          if((highlightCellData.cell_type === 'convert_out' && highlightCellData.product_group_id) || (highlightCellData.cell_type === 'arrival_info' )) {
            cell.focus();
          }else{
            // Click the cell (your existing click handler will handle highlighting)
            cell.click();
          }
          
          // Clear highlight data
          setHighlightCellData(null);
        }
      }, 500); // Wait for table to render
    }
  }, [highlightCellData, inoutData]);

  // Populate selectedProductsData when products load from URL redirect
  useEffect(() => {
    if (productData.length > 0 && productIds.length > 0 && selectedProductsData.length === 0) {
      // Find products that match the productIds from URL
      const matchedProducts = productData.filter(product => productIds.includes(product.id));
      if (matchedProducts.length > 0) {
        setSelectedProductsData(matchedProducts);
      }
    }
  }, [productData, productIds, selectedProductsData.length]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      // ESC key closes any open modal
      if (event.key === 'Escape' && (modalReserve || arrivalModalShow || productGroupLabelModal || productLabelModal)) {
        handleCloseModal();
      }
      // Enter key submits the form in modals
      if ((event.key === 'Enter' || event.key === 'return') && modalReserve) {
        event.preventDefault();
        document.getElementById('modal-save-btn')?.click();
      }

      if (event.key === 'Enter' && arrivalModalShow) {
        event.preventDefault();
        document.getElementById('arrival_modal')?.click();
      }
      if (event.key === 'Enter' && productGroupLabelModal) {
        event.preventDefault();
        document.getElementById('modal-save-btng')?.click();
      }
      if (event.key === 'Enter' && productLabelModal) {
        event.preventDefault();
        document.getElementById('modal-save-btnp')?.click();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [modalReserve, arrivalModalShow, productGroupLabelModal, productLabelModal]);

  useEffect(() => {
    dispatch(fetchPermissionData()); // Fetch data only if not already available
  }, []);

  useEffect(() => {
    if (modalReserve || arrivalModalShow) {
      // Focus the first focusable element when modal opens
      const modal = modalRef.current;
      if (modal) {
        const focusableElements = modal.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (focusableElements.length > 0) {
          focusableElements[0].focus();
        }

        // Trap focus within modal
        const handleTabKey = (e) => {
          if (e.key === 'Tab') {
            const focusableElements = modal.querySelectorAll(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if (!e.shiftKey && document.activeElement === lastElement) {
              firstElement.focus();
              e.preventDefault();
            }

            if (e.shiftKey && document.activeElement === firstElement) {
              lastElement.focus();
              e.preventDefault();
            }
          }
        };

        modal.addEventListener('keydown', handleTabKey);
        return () => modal.removeEventListener('keydown', handleTabKey);
      }
    }
  }, [modalReserve, arrivalModalShow]);

  const handleCloseModal = () => {
    setProductGroupLabelModal(false)
    setArrivalModalShow(false)
    setModalReserve(false);
    setReserveModalUpdateData([]);
    setReserveModalError('');
    setIsEditing('');
    setUpdateValue(null);
    setUpdateId(null);
    setUpdateDate(null);
    setUpdateProduct(null);
    setProductLabelModal(false)
    setAddColumnModal(false)
  };





  // Optimize API calls with useCallback
  // const fetchBrandData = useCallback(async () => {
  //   try {
  //     const resp = await getApi(`/brand`);
  //     if (resp?.success) {
  //       setBrandData(resp?.data?.brands);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching brand data:', error);
  //   }
  // }, []);

  const fetchProductTypesData = useCallback(async () => {
    try {
      const resp = await getApi(`/product_types`);
      if (resp?.success) {
        setTypesData(resp?.data?.data);
      }
    } catch (error) {
      console.error('Error fetching types data:', error);
    }
  }, []);

  // const fetchCategoryData = useCallback(async () => {
  //   try {
  //     const resp = await getApi(`/direct_inout/v2/product-category?per_page=9999`);
  //     if (resp?.success === true) {
  //       setCategoryData(resp?.data?.productCategories?.data || []);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching category data:', error);
  //   }
  // }, []);

  // const fetchOriginData = useCallback(async () => {
  //   try {
  //     const resp = await getApi(`/product-origin?per_page=9999`);
  //     if (resp?.success === true) {
  //       setOriginData(resp?.data?.productOrigins?.data || []);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching origin data:', error);
  //   }
  // }, []);

  const fetchPicImportData = useCallback(async () => {
    try {
      const resp = await getApi(`/product_pic_staff_member?type=import`);
      if (resp?.success === true) {
        setPicImportData(resp?.data?.data || []);
      }
    } catch (error) {
      console.error('Error fetching PIC import data:', error);
    }
  }, []);

  const fetchPicSalesData = useCallback(async () => {
    try {
      const resp = await getApi(`/product_pic_staff_member?type=sales`);
      if (resp?.success === true) {
        setPicSalesData(resp?.data?.data || []);
      }
    } catch (error) {
      console.error('Error fetching PIC sales data:', error);
    }
  }, []);

  const fetchGrFilterData = useCallback(async () => {
    try {
      const resp = await getApi(`/product_group_names?per_page=9999`);
      if (resp?.success === true) {
        setProductGroupVarietyFilterData(resp?.data?.productGroupNames || []);
      }
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  }, []);
  const fetchLabels = useCallback(async (search = "") => {
    try {
      const queryParams = new URLSearchParams({ search });

      const resp = await getApi(`/customer-group/labels?${queryParams.toString()}`);
      if (resp?.success === true) {
        setLabels(resp?.data?.labels || []);
      }
    } catch (error) {
      console.error('Error fetching labels data:', error);
    }
  }, []);
  //expolode comma separated string to array
  const fetchLableCustomerGroups = useCallback(async (lable) => {
    try {
      const queryParams = new URLSearchParams({ 'label': lable });
      const resp = await getApi(`/customer-group/labels/customer-groups?${queryParams.toString()}`);
      if (resp?.success === true) {
        setLabelCustomerGroups(resp?.data?.customerGroups || []);
      }
    } catch (error) {
      console.error('Error fetching customerGroups data:', error);
    }
  }, []);
  const fetchCustomerSubGroups = useCallback(async (search = '') => {
    try {
      const queryParams = new URLSearchParams({ search });
      const resp = await getApi(`/customer-sub-group?${queryParams.toString()}`);
      if (resp?.success === true) {
        setCustomerSubGroups(resp?.data?.customerSubGroups || []);
      }
    } catch (error) {
      console.error('Error fetching customerSubGroups data:', error);
    }
  }, []);

  //expolode comma separated string to array
  const explodeCommaSeparatedString = (str) => {
    if (!str) return [];
    return str.split(',').map(item => item.trim());
  };
  const getArrivalsData = async () => {
    await getInOutData(true)
  }
  const getInOutData = async (arrivalsOnly=false) => {
    if (productIds?.length === 0) {
      setInoutData({});
      setProductSearchInput('');
      setSelectAll(false);
      setExcludedProductIds([]);
      setCurrentPinkSectionPage(1)
      setTotalPinkPages(0)
      return;
    }
    // setTableLoader(true)
    if (currentPinkSectionPage == 1) {
      setLoader(true)

    } else {
      setPinkSectionLoading(true);
    }
    try {
      const startDate = new Date(dateState?.startDate);
      const toDate = new Date(dateState?.endDate);
      const allDate = eachDayOfInterval({ start: startDate, end: toDate })
      setAllDates(allDate);
      const calculatedTotalPages = Math.ceil(allDate.length / itemsPerPage);
      setTotalPages(calculatedTotalPages);
      const startIdx = (currentPage - 1) * itemsPerPage;
      const endIdx = startIdx + itemsPerPage;
      const currentDates = allDate.slice(startIdx, endIdx);
      const fromDate = format((currentDates[0]), 'yyyy-MM-dd');
      // const fromDate = format(addDays(currentDates[0], 1), 'yyyy-MM-dd');
      const endDate = format(addDays(currentDates[currentDates.length - 1], 1), 'yyyy-MM-dd');
      const queryParams = new FormData();
      // const queryParams = new URLSearchParams();
      if (!selectAll) {
        if (Array.isArray(productIds)) {
          productIds.forEach((id) => queryParams.append('product_ids[]', id));
        } else if (productIds) {
          queryParams.append('product_ids[]', productIds);
        }
      }

      if (selectAll) {

        const initialCount = Array.from(queryParams.entries()).length;

        const appendArrayOrSingle = (key, value) => {
          if (Array.isArray(value)) {
            value.forEach((v) => queryParams.append(key, v));
          } else if (value) {
            queryParams.append(key, value);
          }
        };

        if (selectedProductGroupVarietyIds?.length > 0) {
          selectedProductGroupVarietyIds.forEach((commaSeparatedIdsString) => {
            explodeCommaSeparatedString(commaSeparatedIdsString).forEach((id) => {
              queryParams.append('product_ids[]', id)
            });
          });
        }
        appendArrayOrSingle('exclude_product_ids[]', excludedProductIds);
        appendArrayOrSingle('category_ids[]', selectedCategoryIds);
        appendArrayOrSingle('origin_ids[]', selectedOriginIds);
        appendArrayOrSingle('brands[]', selectedBrandName);
        appendArrayOrSingle('types[]', selectedType);
        appendArrayOrSingle('pic_staff_member_import[]', selectedPicImport);
        appendArrayOrSingle('pic_staff_member_sales[]', selectedPicSales);
        appendArrayOrSingle('search', searchValue);

        const finalCount = Array.from(queryParams.entries()).length;

        if (finalCount === initialCount) {
          // Nothing was appended
          return;
        }
      }
      queryParams.append('from_date', fromDate);
      queryParams.append('to_date', endDate);
      queryParams.append('individual', isIndividual);
      // if (searchValue !== '') {
      // {(searchValue!=='' && selectedCategoryIds?.length==0 && selectedOriginIds?.length==0 && productIds?.length=== productData?.length) &&
      //   queryParams.append('search', searchValue);
      // }
      queryParams.append('page', currentPinkSectionPage);

      const resp = await postApi(`/prepack_in_out`, queryParams);
      if (resp?.success === true) {
        // setInoutData(resp?.data)
        // if(arrivalsOnly){
        //   setInoutData(prev => {
        //     return {
        //       ...prev,
        //       arrivals: {
        //         ...resp.data.arrivals,
        //       },
        //     } 
        //   });
        //   return;
        // }
        setTotalPinkPages(resp.data?.sections?.last_page)
        setInoutData(prev => {
          if (isEmptyObject(prev) || currentPinkSectionPage === 1) return resp.data;

          const mergeArray = (a, b) => {
            const safeA = Array.isArray(a) ? a : [];
            const safeB = Array.isArray(b) ? b : [];
            return [...safeA, ...safeB];
          };
          return {
            ...resp.data,

            arrivals: {
              data: mergeArrivalsData(prev.arrivals?.data, resp.data.arrivals?.data),
            },

            customerGroups: {
              ...prev.customerGroups,
              ...resp.data.customerGroups,
            },
            inventories: {
              product: {
                ...prev.inventories.product,
                ...resp.data.inventories.product,
              },
              productGroup: {
                ...prev.inventories.productGroup,
                ...resp.data.inventories.productGroup,
              },
            },
            sectionArrivals: {
              productGroup: {
                heading: {
                  ...prev.sectionArrivals.productGroup.heading,
                  ...resp.data.sectionArrivals.productGroup.heading,
                },
                data: { ...prev.sectionArrivals.productGroup.data, ...resp.data.sectionArrivals.productGroup.data },
                history: { ...prev.sectionArrivals.productGroup.history, ...resp.data.sectionArrivals.productGroup.history },
              },
              product: {
                heading: {
                  ...prev.sectionArrivals.product.heading,
                  ...resp.data.sectionArrivals.product.heading,
                },
                data: { ...prev.sectionArrivals.product.data, ...resp.data.sectionArrivals.product.data },
                history: { ...prev.sectionArrivals.product.history, ...resp.data.sectionArrivals.product.history },
              },
            },



            mainProductOfGroups: {
              ...prev.mainProductOfGroups,
              ...resp.data.mainProductOfGroups,
            },

            productOrderArrivals: {
              ...prev.productOrderArrivals,
              ...resp.data.productOrderArrivals,
            },

            sectionReserves: {
              productGroup: {
                heading: {
                  ...prev.sectionReserves.productGroup.heading,
                  ...resp.data.sectionReserves.productGroup.heading,
                },
                data: { ...prev.sectionReserves.productGroup.data, ...resp.data.sectionReserves.productGroup.data },
                history: { ...prev.sectionReserves.productGroup.history, ...resp.data.sectionReserves.productGroup.history },
              },
              product: {
                heading: {
                  ...prev.sectionReserves.product.heading,
                  ...resp.data.sectionReserves.product.heading,
                },
                data: { ...prev.sectionReserves.product.data, ...resp.data.sectionReserves.product.data },
                history: { ...prev.sectionReserves.product.history, ...resp.data.sectionReserves.product.history },
              },
            },
             convertIns: {
              ...prev.convertIns,
              product: {
                ...prev.convertIns.product,
                data: mergeConvertIns(
                  prev.convertIns.product.data,
                  resp.data.convertIns.product?.data
                ),
              },
              productGroup: {
                ...prev.convertIns.productGroup,
                data: mergeConvertIns(
                  prev.convertIns.productGroup.data,
                  resp.data.convertIns.productGroup?.data
                ),
              },
            },
            convertOuts: {
              ...prev.convertOuts,
              product: {
                ...prev.convertOuts.product,
                data: mergeConvertOuts(
                  prev.convertOuts.product.data,
                  resp.data.convertOuts.product?.data
                ),
                history: mergeConvertOuts(
                  prev.convertOuts.product.history,
                  resp.data.convertOuts.product?.history
                ),
              },
              productGroup: {
                ...prev.convertOuts.productGroup,
                data: mergeConvertOuts(
                  prev.convertOuts.productGroup.data,
                  resp.data.convertOuts.productGroup?.data
                ),
                history: mergeConvertOuts(
                  prev.convertOuts.productGroup.history,
                  resp.data.convertOuts.productGroup?.history
                ),
              },
            },
            sections: {
              ...resp.data.sections,
              data: mergeArray(prev.sections.data, resp.data.sections.data),
            },
          };
        });

        // setTableLoader(false)
        // setLoader(false)
      }
    } catch (error) {
      console.error('Error in processing:', error);
    } finally {
      // setTableLoader(false)
      setLoader(false)
      setPinkSectionLoading(false);
    }
  }
  const handleExport = async () => {
    if (productIds?.length === 0) {
      return;
    }
    setExportLoading(true);

    try {
      const fromDate = new Date(dateState?.startDate);
      const endDate = new Date(dateState?.endDate);
      const queryParams = new FormData();

      if (!selectAll) {
        if (Array.isArray(productIds)) {
          productIds.forEach((id) => queryParams.append('product_ids[]', id));
        } else if (productIds) {
          queryParams.append('product_ids[]', productIds);
        }
      }

      if (selectAll) {
        const initialCount = Array.from(queryParams.entries()).length;

        const appendArrayOrSingle = (key, value) => {
          if (Array.isArray(value)) {
            value.forEach((v) => queryParams.append(key, v));
          } else if (value) {
            queryParams.append(key, value);
          }
        };

        if (selectedProductGroupVarietyIds?.length > 0) {
          selectedProductGroupVarietyIds.forEach((commaSeparatedIdsString) => {
            explodeCommaSeparatedString(commaSeparatedIdsString).forEach((id) => {
              queryParams.append('product_ids[]', id)
            });
          });
        }
        appendArrayOrSingle('exclude_product_ids[]', excludedProductIds);
        appendArrayOrSingle('category_ids[]', selectedCategoryIds);
        appendArrayOrSingle('origin_ids[]', selectedOriginIds);
        appendArrayOrSingle('brands[]', selectedBrandName);
        appendArrayOrSingle('types[]', selectedType);
        appendArrayOrSingle('pic_staff_member_import[]', selectedPicImport);
        appendArrayOrSingle('pic_staff_member_sales[]', selectedPicSales);
        appendArrayOrSingle('search', searchValue);


        const finalCount = Array.from(queryParams.entries()).length;

        if (finalCount === initialCount) {
          return;
        }
      }
      queryParams.append('individual', isIndividual);
      queryParams.append('from_date', format((fromDate), 'yyyy-MM-dd'));
      queryParams.append('to_date', format((endDate), 'yyyy-MM-dd'));
      queryParams.append('export', 1);
      if (showGroupData) {
        queryParams.append('grouping_expanded', showGroupData);
      }
      queryParams.append('arrival_expanded', +showAllArrivals);

      await exportPrepackInOut(queryParams)

    } catch (error) {
      console.error('Error in processing:', error);
    } finally {
      setExportLoading(false);
    }
  }
  const mergeConvertIns = (prev = {}, next = {}, updateIds = null) => {
    const result = { ...prev };

    if (updateIds) {
      const idsToCheck = Array.isArray(updateIds) ? updateIds : [updateIds];
      idsToCheck.forEach(id => {
        if (result[id] && (!next || !next[id])) {
          delete result[id];
        }
      });
    }
  
    if (next) {
      Object.keys(next).forEach(id => {
        result[id] = next[id];
        //  result[id] = {
        //   ...(prev[id] || {}),
        //   ...next[id],
        // };
      });
    }
  
    return result;
  };
  
  
  const mergeConvertOuts = (prev = {}, next = {}) => {
    const result = { ...prev };
  
    Object.keys(next).forEach(id => {
      result[id] = result[id] || {};
  
      Object.keys(next[id]).forEach(date => {
        result[id][date] = {
          ...(prev[id]?.[date] || {}),
          ...next[id][date],
        };
      });
    });
  
    return result;
  };

  const mergeArrivalsData = (prev = {}, next = {}) => {
    const result = { ...prev };

    Object.keys(next).forEach(date => {
      const prevList = prev[date] || [];
      const nextList = next[date] || [];

      // Combine lists and filter duplicates by id
      const combined = [...prevList, ...nextList];
      const uniqueMap = new Map();
      combined.forEach(item => {
        if (item?.id) {
          uniqueMap.set(item.id, item);
        }
      });
      result[date] = Array.from(uniqueMap.values());
    });

    return result;
  };
  const getFinishedProductSection = (finishedProductId) => {
    const section = inoutData.sections.data.find((section) =>{
      if(section.product_ids.includes(finishedProductId)){
        return section;
      }
      return null;
    });
    return section;
  }
  const debounceGetReserveUpdateTimer = useRef();
  const getInOutDataForReserveUpdateInternal = async (updateIds = null) => {
    setLoader(true)
    try {
      const startDate = new Date(dateState?.startDate);
      const toDate = new Date(dateState?.endDate);
      const allDate = eachDayOfInterval({ start: startDate, end: toDate })
      setAllDates(allDate);
      const calculatedTotalPages = Math.ceil(allDate.length / itemsPerPage);
      setTotalPages(calculatedTotalPages);
      const startIdx = (currentPage - 1) * itemsPerPage;
      const endIdx = startIdx + itemsPerPage;
      const currentDates = allDate.slice(startIdx, endIdx);
      const fromDate = format((currentDates[0]), 'yyyy-MM-dd');
      const endDate = format(addDays(currentDates[currentDates.length - 1], 1), 'yyyy-MM-dd');
      const queryParams = new FormData();
      let finishedProductGroupId = null;
      if (updateIds) {
        const finishedProductSection = getFinishedProductSection(updateIds);
        if (finishedProductSection) {
          finishedProductGroupId = finishedProductSection.product_group_id;
        }
      }
      const idsToUse = updateIds || groupProductIds;
      if (Array.isArray(idsToUse)) {
        idsToUse.forEach((id) => queryParams.append('product_ids[]', id));
      } else if (idsToUse) {
        queryParams.append('product_ids[]', idsToUse);
      }
      console.log('quary param', queryParams)
      queryParams.append('from_date', fromDate);
      queryParams.append('to_date', endDate);
      queryParams.append('page', 1);
      queryParams.append('individual', isIndividual);

      const resp = await postApi(`/prepack_in_out`, queryParams);
      if (resp?.success === true) {
        // setInoutData(resp?.data)

        // setTotalPinkPages(resp.data?.sections?.last_page)
        setInoutData(prev => {

          const respIns = resp.data?.convertIns ?? {};
          const respOuts = resp.data?.convertOuts ?? {};


          return {
            ...prev,

            sectionArrivals: {
              productGroup: {
                heading: {
                  ...prev.sectionArrivals?.productGroup?.heading,
                  ...resp.data.sectionArrivals?.productGroup?.heading,
                },
                data: { ...prev.sectionArrivals?.productGroup?.data, ...resp.data.sectionArrivals?.productGroup?.data },
                history: { ...prev.sectionArrivals?.productGroup?.history, ...resp.data.sectionArrivals?.productGroup?.history },
              },
              product: {
                heading: {
                  ...prev.sectionArrivals?.product?.heading,
                  ...resp.data.sectionArrivals?.product?.heading,
                },
                data: { ...prev.sectionArrivals?.product?.data, ...resp.data.sectionArrivals?.product?.data },
                history: { ...prev.sectionArrivals?.product?.history, ...resp.data.sectionArrivals?.product?.history },
              },
            },
            arrivals: {
              data: mergeArrivalsData(prev.arrivals?.data, resp.data.arrivals?.data),
            },


            customerGroups: {
              ...prev.customerGroups,
              ...resp.data?.customerGroups,
            },
            customerGroupsV2: {
              ...prev.customerGroupsV2,
              ...resp.data?.customerGroupsV2,
            },
            inventories: {
              product: {
                ...prev.inventories.product,
                ...resp.data.inventories.product,
              },
              productGroup: {
                ...prev.inventories.productGroup,
                ...resp.data.inventories.productGroup,
              },
            },






            sectionReserves: {
              productGroup: {
                heading: {
                  ...prev.sectionReserves.productGroup.heading,
                  ...resp.data.sectionReserves.productGroup.heading,
                },
                data: { ...prev.sectionReserves.productGroup.data, ...resp.data.sectionReserves.productGroup.data },
                history: { ...prev.sectionReserves.productGroup.history, ...resp.data.sectionReserves.productGroup.history },
              },
              product: {
                heading: {
                  ...prev.sectionReserves.product.heading,
                  ...resp.data.sectionReserves.product.heading,
                },
                data: { ...prev.sectionReserves.product.data, ...resp.data.sectionReserves.product.data },
                history: { ...prev.sectionReserves.product.history, ...resp.data.sectionReserves.product.history },
              },
            },
            convertIns: {
              ...prev.convertIns,
              product: {
                ...prev.convertIns.product,
                data: mergeConvertIns(
                  prev.convertIns.product.data,
                  respIns.product?.data,
                  idsToUse
                ),
              },
              productGroup: {
                ...prev.convertIns.productGroup,
                data: mergeConvertIns(
                  prev.convertIns.productGroup.data,
                  respIns.productGroup?.data,
                  finishedProductGroupId
                ),
              },
            },
            convertOuts: {
              ...prev.convertOuts,
              product: {
                ...prev.convertOuts.product,
                data: mergeConvertOuts(
                  prev.convertOuts.product.data,
                  respOuts.product?.data
                ),
                history: mergeConvertOuts(
                  prev.convertOuts.product.history,
                  respOuts.product?.history
                ),
              },
              productGroup: {
                ...prev.convertOuts.productGroup,
                data: mergeConvertOuts(
                  prev.convertOuts.productGroup.data,
                  respOuts.productGroup?.data
                ),
                history: mergeConvertOuts(
                  prev.convertOuts.productGroup.history,
                  respOuts.productGroup?.history
                ),
              },
            },


          };
        });

        // setTableLoader(false)
        setLoader(false)
        return resp;
      }
      return null;
    } catch (error) {
      console.error('Error in processing:', error);
      return null;
    } finally {
      // setTableLoader(false)
      setLoader(false)
      if (!productLabelModal && !productGroupLabelModal) {
        setGroupProductIds(null)
      }
      setInputValues({});
    }
  }

  const getInOutDataForReserveUpdate = (updateIds = null) => {
    if (debounceGetReserveUpdateTimer.current) {
      clearTimeout(debounceGetReserveUpdateTimer.current);
    }
    return new Promise((resolve) => {
      debounceGetReserveUpdateTimer.current = setTimeout(async () => {
        const result = await getInOutDataForReserveUpdateInternal(updateIds);
        resolve(result);
      }, 1600);
    });
  }

  const debounceUpdateReserveTimers = useRef({});
  const debouncedUpdateReserveData = async (data, value, keyId) => {
    // Handle complex value formats like "old value->new value"
    let numericValue = value;
    if (typeof value === 'string' && value.includes('->')) {
      // Extract the part after "->" if it exists
      const parts = value.split('->');
      numericValue = parts[parts.length - 1].trim();
    }

    // Ensure we have a valid number, default to 0 if invalid
    const parsedNumber = Number(numericValue);
    const val = isNaN(parsedNumber) ? '0' : String(parsedNumber);
    let newCreatedReserveId = null;
    // Clear previous timeout if still waiting
    // if (debounceTimer.current) {
    //   clearTimeout(debounceTimer.current);
    // }
    if (debounceUpdateReserveTimers.current[keyId]) {
      clearTimeout(debounceUpdateReserveTimers.current[keyId]);
    }

    // Update state immediately (not debounced) - always set inputValues regardless of data.id
    console.log(`Setting inputValues for ${keyId}:`, val);
    setInputValues(prev => ({
      ...prev,
      [keyId]: val
    }));

    // Set a new timeout for the API calls
    debounceUpdateReserveTimers.current[keyId] = setTimeout(async () => {
      try {
        // setLoader(true)
        if (data?.id) {
          // update
          const urlEncodedData = new URLSearchParams();
          urlEncodedData.append('quantity', val || 0);
          const resp = await putApi(`/reserve/${data?.id}`, urlEncodedData.toString());

          if (resp?.success === true) {
            // setReserveUpdateData([]);
            // setInputValues({});
            setModalReserve(false);
            // setProductLabelModal(false)
            // setReserveModalUpdateData([]);
            // setSelectedProductId(null);
            // setQuantityValue(0);
            // getInOutData();
            getInOutDataForReserveUpdate();
            // setProductGroupLabelModal(false)
          }
          else {
            setLoader(false)
          }
        } else {
          // create
          const urlEncodedData = new URLSearchParams();
          urlEncodedData.append('start_date', data?.date);
          urlEncodedData.append('end_date', data?.date);
          urlEncodedData.append('customer_group_id', data?.customer_group_name);
          urlEncodedData.append('customer_sub_group_id', data?.customer_sub_group_name);
          urlEncodedData.append(`dates[0][date]`, data?.date);
          urlEncodedData.append(`dates[0][quantity]`, val || '0');

          if (data?.type === 'productGroup') {
            const resp = await getApi(`/product-group/${data?.product_group_name}`);
            if (resp?.success === true) {
              const mainProduct = resp?.data?.productGroup?.products.find(product => product.is_main_product === 1);
              if (mainProduct) {
                urlEncodedData.append('product_id', mainProduct.id);
                // setGroupProductIds(mainProduct.id);
                const response = await postApi('/reserve', urlEncodedData.toString());
                if (response?.success === true) {
                  // getInOutData();
                  newCreatedReserveId = response?.data?.id;

                  getInOutDataForReserveUpdate();
                }
              } else {
                toast.error('No main product found');
              }
            }
          } else {
            urlEncodedData.append('product_id', data?.product_name);
            // setGroupProductIds(data?.product_name);
            const response = await postApi('/reserve', urlEncodedData.toString());
            if (response?.success === true) {
              // getInOutData();
              newCreatedReserveId = response?.data?.id;
              getInOutDataForReserveUpdate();
            } else {
              setLoader(false)
            }
          }
        }
        const updatedLabelData = [...labelData]; // clone array
        let mainGroup = updatedLabelData[0];
        let labelIndex = 0
        if (data?.type === 'productGroup' || data?.product_group_id) {
          for (let i = 0; i < updatedLabelData.length; i++) {
            if (updatedLabelData[i].groupLabel[0].customer_group_id === selectedProductId) {

              mainGroup = updatedLabelData[i];
              labelIndex = i;
              break;
            }
          }
        }

        if (mainGroup) {
          const exists = mainGroup.subGroups.find(
            (subgroup) => subgroup.id === data.customer_sub_group_name || subgroup.id === data.id
          );

          if (!exists) {
            const newLabelDataObject = {
              customer_group_id: selectedProductId, // or data.customer_group_name
              quantity: val,
            }
            if (data?.type !== 'productGroup' && !data?.product_group_id) {
              if (newCreatedReserveId) {
                newLabelDataObject.id = newCreatedReserveId
              }
            }
            mainGroup.subGroups.push(newLabelDataObject);
          } else {
            // Optional: update quantity if already exists
            mainGroup.subGroups = mainGroup.subGroups.map((subgroup) => {
              if (subgroup.id === data.customer_sub_group_name || subgroup.id === data.id) {
                return { ...subgroup, quantity: val };
              }
              return subgroup;
            });
          }

          updatedLabelData[labelIndex] = mainGroup;
          setLabelData(updatedLabelData);
        }
        // setLoader(false) // Changed from setToastMessage(false)
        setIsEditing('');
        // setUpdateValue(null);
        // setUpdateId(null);
        // setUpdateDate(null);
        // setUpdateProduct(null);
        // setLabelDate(null);
        // setLabelData(updatedLabelData);
        // setSubGroup('');
        // setSubGroupName('');
        // setGroupName('');
        // setProductName('');
        // setProductLabelModal(false);
        // setSelectedProductId(null);
        // setProductGroupLabelModal(false)
      } catch (error) {
        setLoader(false)
        setIsEditing('');
        // setUpdateValue(null);
        // setUpdateId(null);
        // setUpdateDate(null);
        // setUpdateProduct(null);
        // setLabelDate(null);
        // setLabelData([]);
        // setSubGroup('');
        // setSubGroupName('');
        // setGroupName('');
        // setProductName('');
        // setProductLabelModal(false);
        // setSelectedProductId(null);
        setProductGroupLabelModal(false)
        // setGroupProductIds(null)
        console.error('Error in debounced API call:', error);
      }
    }, 1500);
  };
  const debounceUpdateConvertOutTimers = useRef({});
  const debouncedUpdateConvertOutData = async (data, keyId) => {
    
    if (debounceUpdateConvertOutTimers.current[keyId]) {
      clearTimeout(debounceUpdateConvertOutTimers.current[keyId]);
    }
 
    // Set a new timeout for the API calls
    debounceUpdateConvertOutTimers.current[keyId] = setTimeout(async () => {
      try {
        // setLoader(true)
        if (data?.id) {
          // update
          const urlEncodedData = new URLSearchParams();
          const quantity = parseInt(data?.quantity, 10) || 0;
          urlEncodedData.append('quantity', quantity);
          urlEncodedData.append('date', data?.date);
          const resp = await putApi(`/prepack-manual-convert-out/${data?.id}`, urlEncodedData.toString());

          if (resp?.success === true) {
 
            setModalConvertOut(false);
     
            getInOutDataForReserveUpdate();
          }
          else {
            setLoader(false)
          }
        } else {
          // create
          const urlEncodedData = new URLSearchParams();
          urlEncodedData.append('raw_product_id', data?.raw_product_id);
          urlEncodedData.append('finished_product_id', data?.finished_product_id);
          urlEncodedData.append('date', data?.date);
          const quantity = parseInt(data?.quantity, 10) || 0;
          urlEncodedData.append('quantity', quantity);

          const response = await postApi('/prepack-manual-convert-out', urlEncodedData.toString());
          if (response?.success === true) {
            await getInOutDataForReserveUpdate(data?.finished_product_id);
           setConvertOutInputs(prev => ({ ...prev, [keyId]: null }));
          }
          else {
            setLoader(false)
          }
        }

      } catch (error) {
        setLoader(false)
        console.error('Error in debounced API call:', error);
      }
    }, 1500);
  };
  const hasRowIndex = (obj, rowIndex) => {
    return Object.keys(obj).some(key => key.startsWith(`${rowIndex}-`));
  };
  const updateArrivalOrderRemarkOnDrop = async (droppedData, toEtaDate) => {
    console.log('droppedData', droppedData, toEtaDate);
    if (!droppedData.data) {
      console.log('no data found');
      return;
    }
    try {
      setLoader(true)

      const res = await putApi(`/arrival-summary/eta/${droppedData?.data?.id}/update`, { eta: toEtaDate });

      if (res.success) {
        setInoutData(prev => {
          const fromEtaDate = droppedData?.data?.eta; // original
          const oldSourceArrivals = prev.arrivals.data[fromEtaDate] || [];
          const newSourceArrivals = oldSourceArrivals.filter(
            item => item.id !== droppedData?.data?.id
          );

          const oldDestArrivals = prev.arrivals.data[toEtaDate] || [];
          const newDestArrivals = [...oldDestArrivals, { ...droppedData?.data, eta: toEtaDate }];

          return {
            ...prev,
            arrivals: {
              ...prev.arrivals,
              data: {
                ...prev.arrivals.data,
                [fromEtaDate]: newSourceArrivals,
                [toEtaDate]: newDestArrivals,
              },
            },
          };
        });

        toast.success(res.message);
        if (currentPinkSectionPage === 1) {
          getInOutData();

        } else {
          setCurrentPinkSectionPage(1);
        }
        if (hasRowIndex(selectedCellsForSum, droppedData?.sourceRowIndex)) {
          setSelectedCellsForSum({})
        }
      } else {
        toast.error(res.message);
      }

    } catch (err) {
      console.error("Update failed", err);
    } finally {

      setLoader(false)
    }

  };

  useEffect(() => {
    const fetchInitialData = async () => {
      await Promise.all([
        // fetchBrandData(),
        fetchProductTypesData(),
        // fetchCategoryData(),
        // fetchOriginData(),
        fetchPicImportData(),
        fetchPicSalesData(),
        fetchGrFilterData(),
        fetchCustomerSubGroups(),
        fetchLabels()
      ]);
    };

    fetchInitialData();
    setArrivalModalShow(false);
    setModalReserve(false);
  }, [
    // fetchBrandData, 
    fetchProductTypesData,
    // fetchCategoryData,
    //  fetchOriginData, 
    fetchPicImportData, fetchPicSalesData,
    fetchGrFilterData,
    fetchCustomerSubGroups, fetchLabels
  ]);



  useEffect(() => {
    const trimmedSearch = searchValue.trim();
    const hasCategory = selectedCategoryIds?.length > 0;
    const hasOrigin = selectedOriginIds?.length > 0;
    const hasBrand = selectedBrandName?.length > 0;
    const hasType = selectedType?.length > 0;
    const hasSales = selectedPicSales?.length > 0;
    const hasImport = selectedPicImport?.length > 0;
    const hasProductGroupVariety = selectedProductGroupVarietyIds?.length > 0;
    const hasSearch = trimmedSearch !== '';
    const hasAnyFilter = hasCategory || hasOrigin || hasBrand || hasType || hasSales || hasImport || hasSearch || hasProductGroupVariety;

    if (!hasAnyFilter) return;

    fetchProducts('pageChange');
  }, [perPageSearch, expandProductRows]);


  useEffect(() => {
    const trimmedSearch = searchValue.trim();
    const hasCategory = selectedCategoryIds?.length > 0;
    const hasOrigin = selectedOriginIds?.length > 0;
    const hasBrand = selectedBrandName?.length > 0;
    const hasType = selectedType?.length > 0;
    const hasSales = selectedPicSales?.length > 0;
    const hasImport = selectedPicImport?.length > 0;
    const hasProductGroupVariety = selectedProductGroupVarietyIds?.length > 0;
    const hasSearch = trimmedSearch !== '';
    const hasAnyFilter = hasCategory || hasOrigin || hasBrand || hasType || hasSales || hasImport || hasSearch || hasProductGroupVariety;
    console.log('selectedProductGroupVarietyIds', selectedProductGroupVarietyIds);
    if (!hasAnyFilter && !finishedProductIdFromUrl) {
      // Reset everything if no filter
      setProductData([]);
      setProductIds([]);
      setSelectedProductsData([]);
      setSelectAll(false);
      setTotalProduct(0);
      setProductLoader(false);
      return;
    }
    setProductLoader(true);
    const timer = setTimeout(async () => {

      if (perPageSearch === 1) {
        fetchProducts();
      } else {
        setPerPageSearch(1);
      }
      if (currentPinkSectionPage === 1) {
        getInOutData();

      } else {
        setCurrentPinkSectionPage(1);
      }
      // setProductLoader(false);

    }, 500); // debounce 500ms

    return () => clearTimeout(timer);
  }, [
    searchValue,
    selectedCategoryIds,
    selectedOriginIds,
    selectedBrandName,
    selectedType,
    selectedPicImport,
    selectedPicSales,
    selectedProductGroupVarietyIds,
    isIndividual
  ]);
  const fetchProducts = async (actionType) => {
    setProductLoader(true);

    const trimmedSearch = searchValue.trim();

    try {
      const queryParams = new URLSearchParams();

      const appendParams = (params, key, values) => {
        if (Array.isArray(values)) {
          values.forEach((v) => params.append(`${key}[]`, v));
        } else if (values) {
          params.append(`${key}[]`, values);
        }
      };
      // if url has finish product id, ehen send in product_ids
      if (finishedProductIdFromUrl) {
        queryParams.append('product_ids[]', finishedProductIdFromUrl);
      }
      if (selectedProductGroupVarietyIds?.length > 0) {
        selectedProductGroupVarietyIds.forEach((commaSeparatedIdsString) => {
          explodeCommaSeparatedString(commaSeparatedIdsString).forEach((id) => {
            queryParams.append('product_ids[]', id)
          });
        });

      }
      appendParams(queryParams, 'category_ids', selectedCategoryIds);
      appendParams(queryParams, 'origin_ids', selectedOriginIds);
      appendParams(queryParams, 'brands', selectedBrandName);
      appendParams(queryParams, 'types', selectedType);
      appendParams(queryParams, 'pic_staff_member_import', selectedPicImport);
      appendParams(queryParams, 'pic_staff_member_sales', selectedPicSales);

      queryParams.append('search', trimmedSearch);
      queryParams.append('page', perPageSearch);

      queryParams.append('per_page', expandProductRows ? 40 : 20);

      const startDate = new Date(dateState?.startDate);
      const toDate = new Date(dateState?.endDate);

      const formatDate = (date) => {
        if (!date || isNaN(date)) return null; // handle invalid date
        return date.toISOString().split("T")[0]; // YYYY-MM-DD
      };

      const formattedStart = formatDate(startDate);
      const formattedEnd = formatDate(toDate);

      queryParams.append('from_date', formattedStart);
      queryParams.append('to_date', formattedEnd);

      const resp = await getApi(`/product/prepack_in_out?${queryParams.toString()}`);


      if (resp?.success === true) {

        //
        setTotalProduct(resp?.data?.products?.total);
        const newProducts = resp?.data?.products?.data || [];

        const shouldMerge = perPageSearch !== 1;
        const finalProducts = shouldMerge ? [...productData, ...newProducts] : newProducts;

        setProductData(finalProducts);

        if (selectAll && finalProducts.length > 0) {
          const mergedById = Array.from(
            new Map(finalProducts.filter(item => !excludedProductIds.includes(item.id)).map(item => [item.id, item])).values()
          );
          handleSelectAll(mergedById);
        }
      } else {
        setProductData([]);
      }


    } catch (error) {

      console.error('Fetch failed', error);

    }
    finally {
      setProductLoader(false);

    }
  };






  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {

      // Priority 1: Trigger when selectAll is false and productIds change
      // if (!selectAll) {
      //   getInOutData();
      //   return;
      // }
      // Priority 2: Trigger when filters/searching updates
      if (
        !selectAll
        ||
        searchValue !== '' ||
        selectedCategoryIds?.length > 0 ||
        selectedOriginIds?.length > 0 ||
        selectedBrandName ||
        selectedType ||
        selectedPicImport ||
        selectedPicSales ||
        selectedProductGroupVarietyIds?.length > 0
      ) {
        if (currentPinkSectionPage === 1) {
          getInOutData();

        } else {
          setCurrentPinkSectionPage(1);
        }

      }
    }, 1000);
    return () => {
      clearTimeout(delayDebounceFn);
    };
  }, [
    dateState,
    selectAll,
    currentPage
  ]);



  useEffect(() => {
    if (!selectAll && productIds?.length > 0) {
      if (currentPinkSectionPage === 1) {
        getInOutData();

      } else {
        setCurrentPinkSectionPage(1);
      }

    }
  }, [
    productIds
  ]);
  useEffect(() => {
    getInOutData();
  }, [
    currentPinkSectionPage
  ]);
  useEffect(() => {
    if (!selectAll || excludedProductIds.length === 0) return;

    const timeoutId = setTimeout(() => {
      getInOutData();
    }, 500);
    return () => clearTimeout(timeoutId);

  }, [excludedProductIds, selectAll]);



  useEffect(() => {
    if (!isSearching) return;
    function handleClickOutside(event) {
      if (
        productSearchRef.current &&
        !productSearchRef.current.contains(event.target)
      ) {
        // Only close if input is empty
        if (!productSearchInput) {
          setIsSearching(false);
        }
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSearching, productSearchInput]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIndividualGroupOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const handleDateFilterChange = (dates) => {
    if (dates) {
      setDateState({
        startDate: dates[0] ? dayjs(dates[0]).format('YYYY-MM-DD') : null,
        endDate: dates[1] ? dayjs(dates[1]).format('YYYY-MM-DD') : null
      });
    } else {
      setDateState({
        startDate: null,
        endDate: null
      });
    }

  }

  const debounceTimer = useRef(null);

  // Add debounced search function
  const debouncedSearch = useCallback((value) => {
    // Immediately update the input value for responsive typing
    setSearchInputValue(value);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      setSearchValue(value);
      setPerPageSearch(1);
    }, 1000);
  }, []);

  const handlePageClick = (selected) => {
    setCurrentPage(selected);
  };

  const handleSaveArrivalData = async () => {
    setArrivalModalLoading(true)
    if (!Array.isArray(arrivalModalData?.products) || arrivalModalData.products.length === 0) {
      setArrivalModalError('No products available.');
      setArrivalModalLoading(false)
      return;
    }
    if (arrivalModalData?.eta == '' || arrivalModalData?.eta == null) {
      setArrivalModalError('ETA field not be empty');
      setArrivalModalLoading(false)
      return;
    }
    const selectedProduct = arrivalModalData.products.find(x => x.id === selectedArrivalProductId) ||
      arrivalModalData.products[0];
    if (!selectedProduct) {
      setArrivalModalError('Selected product not found.');
      setArrivalModalLoading(false)
      return;
    }
    // Here you would typically call your API or update state
    const quantity = arrivalQuantityMap[selectedProduct.id] ?? selectedProduct.quantity;
    const val = {
      quantity: arrivalQuantityMap[selectedArrivalProductData?.id],
      barcode: selectedArrivalProductData?.barcode,
      eta: arrivalModalData?.eta,
    }
    const resp = await putApi(`/arrival-summary/product-update/${selectedArrivalProductData?.arrival_summary_product_id}`, val)
    if (resp?.success === true) {
      if (currentPinkSectionPage === 1) {
        getInOutData();

      } else {

        setCurrentPinkSectionPage(1);
      }
      setArrivalModalShow(false);
      setArrivalModalData({});
      setSelectedArrivalProductId(null);
      setArrivalQuantityMap({});
    }
    setArrivalModalLoading(false)
    setArrivalModalError('');
  }



  useEffect(() => {
    if (
      modalReserve &&
      Array.isArray(reserveModalUpdateData) &&
      reserveModalUpdateData.length > 0
    ) {
      setSelectedProductId(reserveModalUpdateData[0].product_id);
      setQuantityValue(reserveModalUpdateData[0].quantity || 0);
    }
  }, [modalReserve, reserveModalUpdateData]);

  useEffect(() => {
    // if (
    //   labelData &&
    //   labelData[0]?.groupLabel?.length > 0 &&
    //   !selectedProductId // only set if not already set
    // ) {
    //   const first = labelData[0].groupLabel[0];
    //   setSelectedProductId(first.id);
    //   const matchedSubGroup = labelData[0]?.subGroups?.find(
    //     (subgroup) => first.id === subgroup.customer_group_id
    //   );

    //   setQuantityValue(matchedSubGroup?.quantity || 0);
    //   setGroupName(first.id);
    // }
    if (!labelData || labelData.length === 0 || selectedProductId) return;

    const firstItem = labelData[0];

    if (firstItem.subGroups?.length > 0) {
      const firstSub = firstItem.subGroups[0];
      setSelectedProductId(firstSub.id);
      setQuantityValue(firstSub.quantity || 0);
      setGroupName(firstSub.customer_group_id);
    } else if (firstItem.groupLabel?.length > 0) {
      const firstGroup = firstItem.groupLabel[0];
      setSelectedProductId(firstGroup.id);
      setQuantityValue(0);
      setGroupName(firstGroup.id);
    }
  }, [labelData]);

  useEffect(() => {
    if (
      Array.isArray(reserveModalUpdateData) &&
      reserveModalUpdateData.length > 0 &&
      selectedProductId !== null
    ) {
      const selected = reserveModalUpdateData.find(x => x.product_id === selectedProductId);
      if (selected) {
        setQuantityValue(selected.quantity || 0);
      }
    }
  }, [reserveModalUpdateData, selectedProductId]);

  const handleProductId = (data) => {
    console.log('dataaaa', data);
    // setSelectAll(false)
    const id = data?.id;
    if (selectAll) {
      setExcludedProductIds(prev => {
        const newIds = prev.includes(id)
          ? prev.filter(pid => pid !== id)
          : [...prev, id];
        console.log('excluded:', newIds)
        return newIds;

      });

    }
    setProductIds(prev => {
      const newIds = prev.includes(id)
        ? prev.filter(pid => pid !== id)
        : [...prev, id];
      return newIds;
    });

    setSelectedProductsData(prev => {
      const exists = prev.some(p => p.id === id);
      if (exists) {
        return prev.filter(p => p.id !== id);
      } else {
        return [...prev, data];
      }
    });
  }
  const queryParams = {
    'from_date': dateState.startDate,
    'to_date': dateState.startDate,
  }

  // Initialize arrival modal selection when modal opens
  useEffect(() => {
    if (
      arrivalModalShow &&
      Array.isArray(arrivalModalData?.products) &&
      arrivalModalData.products.length > 0
    ) {
      const firstId = arrivalModalData.products[0].id;
      setSelectedArrivalProductId(firstId);
      setSelectedArrivalProductData(arrivalModalData.products[0])
      setArrivalQuantityMap({
        [firstId]: arrivalModalData.products[0].quantity || ''
      });
    }
  }, [arrivalModalShow, arrivalModalData]);

  const handleSelectAll = (data, clearExcludedProductIds = false) => {
    setSelectAll(true)
    if (clearExcludedProductIds) {
      setExcludedProductIds([])
    }
    if (!Array.isArray(data)) return;
    const ids = data.map(item => item.id);
    const dataMap = [];

    data.forEach(item => {
      // dataMap[item.id] = item;
      dataMap.push(item);
    });

    const areArraysEqual = (a, b) =>
      Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(item => b.includes(item)) &&
      b.every(item => a.includes(item));

    if (!areArraysEqual(productIds, ids)) {
      setProductIds(ids);
      setSelectedProductsData(dataMap);
    }
  }

  let scrollTimeout;
  const handleScrollToBottom = (e) => {
    if (scrollTimeout) clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      const { scrollLeft, scrollWidth, clientWidth } = e.target;
      // if (scrollLeft + clientWidth >= scrollWidth - 10) {
      //   if(totalProduct >productData?.length){
      //   setPerPageSearch(prev => prev + 1);
      //   }
      // }
      const scrolledPercentage = (scrollLeft + clientWidth) / scrollWidth;

      // If user scrolled to 80% or more
      if (scrolledPercentage >= 0.8) {
        if (totalProduct > productData?.length) {
          setPerPageSearch(prev => prev + 1);
        }
      }
    }, 300);
  };

  const isDeepEmpty = (obj) => {
    if (Array.isArray(obj)) return obj.length === 0;

    if (typeof obj === 'object' && obj !== null) {
      return Object.values(obj).every(value => isDeepEmpty(value));
    }

    return false; // primitive value or non-empty
  };
  let pinkSectionScrollTimeout;
  const handlePinkSectionScroll = () => {
    if (pinkSectionScrollTimeout) clearTimeout(pinkSectionScrollTimeout);
    pinkSectionScrollTimeout = setTimeout(() => {
      const container = tableContainerRef.current;
      if (!container || loader || pinkSectionLoading) return;

      const scrollLeft = container.scrollLeft;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;

      const scrollPercentage = ((scrollLeft + clientWidth) / scrollWidth) * 100;

      if (scrollPercentage >= 90) {
        setCurrentPinkSectionPage(prev => {
          if (prev + 1 > totalPinkPages) return prev;
          return prev + 1;
        });
      }

    }, 300);
  };

  useEffect(() => {
    const container = tableContainerRef.current;
    if (!container) return;

    container.addEventListener('scroll', handlePinkSectionScroll);
    return () => container.removeEventListener('scroll', handlePinkSectionScroll);
  }, [loader, inoutData]);

  return (
    <>
      <div class="RightSideDiv inout-right">
        {showImportModal && (
          <Import
            setImportFile={setImportFile}
            importFile={importFile}
            searchQuery={''}
            fetchData={() => { currentPinkSectionPage === 1 ? getInOutData() : setCurrentPinkSectionPage(1) }}
            setShowImportModal={setShowImportModal}
            routeEnd={'/reserve/import'}
            routeexport={`/inventory/export`}
            type={'Direct Inout'}
            queryParams={queryParams}
          // setCurrentPinkSectionPage={setCurrentPinkSectionPage}
          />
        )}
        <div className="row">
          <div className="col-sm-12">
            <div className="setting-right setting-right-table table-border-show arrival in-out-page">
              <div class="in-out">
                <div class="table-header  border-bt">
                  <div class="header-left d-flex">
                    <div class="search-card only-arival">
                      <img src={window.getPublicUrl('/assets/images/search-icon.svg')} alt="" />
                      <input type="text" class="search-input" placeholder="Search Product Name/Code" value={searchInputValue} onChange={(e) => debouncedSearch(e?.target?.value)} />
                    </div>

                    <div className='selctions-option'>
                      <input placeholder="category" class={`category ${individualGroupOpen ? 'before-change-cs' : ''} affter-change-cs category-select individual-group-select`} value="Individual/Group" onClick={() => setIndividualGroupOpen(!individualGroupOpen)} />
                      {individualGroupOpen &&
                        <div className='select-option' ref={dropdownRef}>
                          <span>
                            <label class="checbox-cs">
                              <input type="checkbox" onClick={(e) => { setIsIndividual(1); }} checked={isIndividual} />
                              <span class="checkmark" ></span>
                            </label>
                            Individual
                          </span>
                          <span>
                            <label class="checbox-cs">
                              <input type="checkbox" onClick={(e) => { setIsIndividual(0); }} checked={!isIndividual} />
                              <span class="checkmark" ></span>
                            </label>
                            Group
                          </span>
                        </div>
                      }
                    </div>

                    <MultiSelectDropdown
                      categoryData={typesData}
                      selectedCategories={selectedType}
                      setSelectedCategories={setSelectedType}
                      placeholder="Select types..."
                      noOptionsMessage='No Types available'
                      setCurrentPage={setCurrentPage}
                      setCurrentPinkSectionPage={setCurrentPinkSectionPage}
                      fetchOptionsApi={fetchTypeFilter}
                    />
                  </div>
                  <div class="table-actions">
                    {checkAddPermission(data?.permissions, 'prepack_in_out') && (
                      <>
                        <button class="btn add" onClick={() => {
                          navigate('/admin/reserve');
                          localStorage.setItem("reserveMethod", true);
                        }}>
                          + Add Reserve
                        </button>
                        <button class="btn add sales-delivery-report"
                          onClick={() => handleImportClickFile(setShowImportModal, setImportFile, setImportErrors)}>
                          + Sales Delivery Report
                        </button>
                      </>
                    )}
                    {/* <button class="btn" onClick={() => exportData(tableRef)}><img src={window.getPublicUrl('/assets/images/export.svg')} alt="" />Export</button> */}
                    <button className={`btn ${exportLoading ? 'disable-btn' : ''}`} onClick={() => handleExport()} disabled={exportLoading}><img src={window.getPublicUrl('/assets/images/export.svg')} alt="" />Export</button>
                  </div>
                </div>
                <div class="table-header table-second ">
                  <div class="links">
                    <DependentMultiSelectDropdown
                      categoryData={[]}
                      selectedValues={selectedCategoryIds}
                      setSelectedValues={(selected) => {
                        setSelectedCategoryIds(selected);
                        setPerPageSearch(1);
                      }}
                      placeholder='Select Categories...'
                      noOptionsMessage='No categories available'
                      setCurrentPage={setCurrentPage}
                      setCurrentPinkSectionPage={setCurrentPinkSectionPage}
                      fetchOptionsApi={fetchCategoryDataFilterV2}
                      dependentFilters={{
                        search_product_name_code: searchInputValue,
                        origin_ids: selectedOriginIds,
                        brands: selectedBrandName,
                        product_ids: selectedProductGroupVarietyIds,
                        pic_staff_member_import: selectedPicImport,
                        pic_staff_member_sales: selectedPicSales
                      }}
                    />

                    <DependentMultiSelectDropdown
                      categoryData={[]}
                      selectedValues={selectedOriginIds}
                      setSelectedValues={(selected) => {
                        setSelectedOriginIds(selected);
                        setPerPageSearch(1);
                      }}
                      placeholder="Select origin..."
                      noOptionsMessage='No origin available'
                      setCurrentPage={setCurrentPage}
                      setCurrentPinkSectionPage={setCurrentPinkSectionPage}
                      fetchOptionsApi={fetchOriginDataFilterV2}
                      dependentFilters={{
                        search_product_name_code: searchInputValue,
                        category_ids: selectedCategoryIds,
                        brands: selectedBrandName,
                        product_ids: selectedProductGroupVarietyIds,
                        pic_staff_member_import: selectedPicImport,
                        pic_staff_member_sales: selectedPicSales
                      }}
                    />
                    {/* <MultiSelectDropdown
                      categoryData={productGroupVarietyFilterData}
                      selectedCategories={selectedProductGroupVarietyIds}
                      setSelectedCategories={(selected) => {
                        setSelectedProductGroupVarietyIds(selected);
                        setPerPageSearch(1);
                      }}
                      placeholder='Select gr no...'
                      noOptionsMessage='No group available'
                      setCurrentPage={setCurrentPage}
                      setCurrentPinkSectionPage={setCurrentPinkSectionPage}
                      fetchOptionsApi={fetchProductGroupVarietiesFilterData}
                    /> */}
                    <DependentMultiSelectDropdown
                      categoryData={[]}
                      selectedValues={selectedProductGroupVarietyIds}
                      setSelectedValues={(selected) => {
                        setSelectedProductGroupVarietyIds(selected);
                        setPerPageSearch(1);
                      }}
                      placeholder='Select gr no...'
                      noOptionsMessage='No group available'
                      setCurrentPage={setCurrentPage}
                      setCurrentPinkSectionPage={setCurrentPinkSectionPage}
                      fetchOptionsApi={fetchProductGroupVarietiesFilterData}
                      dependentFilters={{
                        search_product_name_code: searchInputValue,
                        category_ids: selectedCategoryIds,
                        origin_ids: selectedOriginIds,
                        brands: selectedBrandName,
                        pic_staff_member_import: selectedPicImport,
                        pic_staff_member_sales: selectedPicSales
                      }}
                    />
                    <DependentMultiSelectDropdown
                      categoryData={[]}
                      selectedValues={selectedBrandName}
                      setSelectedValues={setSelectedBrandName}
                      placeholder="Select brand..."
                      noOptionsMessage='No Brand available'
                      setCurrentPage={setCurrentPage}
                      setCurrentPinkSectionPage={setCurrentPinkSectionPage}
                      fetchOptionsApi={fetchBrandFilterV2}
                      dependentFilters={{
                        search_product_name_code: searchInputValue,
                        category_ids: selectedCategoryIds,
                        origin_ids: selectedOriginIds,
                        product_ids: selectedProductGroupVarietyIds,
                        pic_staff_member_import: selectedPicImport,
                        pic_staff_member_sales: selectedPicSales
                      }}
                    />
                    <div className='selctions-option'>
                      <RangePicker
                        key={'pathName'}
                        onChange={handleDateFilterChange}
                        separator={'-'}
                        value={[
                          dateState.startDate ? dayjs(dateState.startDate) : null,
                          dateState.endDate ? dayjs(dateState.endDate) : null
                        ]}
                        allowClear={false}
                      />
                    </div>
                    <DependentMultiSelectDropdown
                      categoryData={[]}
                      selectedValues={selectedPicImport}
                      setSelectedValues={setSelectedPicImport}
                      placeholder="Select pic import ..."
                      noOptionsMessage='No pic import available'
                      setCurrentPage={setCurrentPage}
                      setCurrentPinkSectionPage={setCurrentPinkSectionPage}
                      fetchOptionsApi={fetchPicImportDataFilterV2}
                      dependentFilters={{
                        search_product_name_code: searchInputValue,
                        category_ids: selectedCategoryIds,
                        origin_ids: selectedOriginIds,
                        brands: selectedBrandName,
                        product_ids: selectedProductGroupVarietyIds,
                        pic_staff_member_sales: selectedPicSales
                      }}
                    />
                    <DependentMultiSelectDropdown
                      categoryData={[]}
                      selectedValues={selectedPicSales}
                      setSelectedValues={setSelectedPicSales}
                      placeholder="Select pic sales..."
                      noOptionsMessage='No pic sales available'
                      setCurrentPage={setCurrentPage}
                      setCurrentPinkSectionPage={setCurrentPinkSectionPage}
                      fetchOptionsApi={fetchPicSalesDataFilterV2}
                      dependentFilters={{
                        search_product_name_code: searchInputValue,
                        category_ids: selectedCategoryIds,
                        origin_ids: selectedOriginIds,
                        brands: selectedBrandName,
                        product_ids: selectedProductGroupVarietyIds,
                        pic_staff_member_import: selectedPicImport,
                      }}
                    />
                  </div>
                </div>

                <div className="main-inout-table-srcoll">
                  <div class="table-container-inner">
                    {(productData?.length > 0 || selectedProductsData?.length > 0) &&
                      <>
                        <div className={`table-left ${expandProductRows ? 'expanded-product-rows' : ''}`}>
                          <div className="header-main header-left">
                            <div className={`header with-input`}>
                              {/* {!isSearching ? (
                            <label onClick={() =>{if(selectedCategoryIds?.length>0 || selectedOriginIds?.length>0){ setIsSearching(true)}}} style={{ cursor: "pointer" }} className='mb-0'>
                              All Products{" "}
                              <img
                                src={window.getPublicUrl("/assets/images/white-seqarch.svg")}
                                alt=""
                              />
                            </label>
                          ) : (
                            // Wrap input and clear button in a div with the ref
                            <div ref={productSearchRef} style={{ display: "flex", alignItems: "center" }}>
                              <input
                                type="text"
                                className="search-input"
                                placeholder="Search Product Name/Code"
                                value={productSearchInput}
                                onChange={(e) => setProductSearchInput(e.target.value)}
                                style={{ marginBottom: 8 }}
                                autoFocus
                              />
                              <img
                                src={window.getPublicUrl("/assets/images/cross-black.svg")}
                                alt="Clear"
                                style={{ cursor: "pointer", marginLeft: 8 }}
                                onClick={() => {
                                  setProductSearchInput("");
                                  setIsSearching(false);
                                }}
                              />
                            </div>
                          )} */}
                              {(productData.length > 0 || selectedProductsData.length > 0) && (<><button type='button' onClick={() => {
                                //  const visibleProducts = productData || [];
                                //  const visibleProduct = selectedProductsData || [];

                                const filteredUnselectedVisibleProducts = productData.filter(
                                  product => !selectedProductsData.some(vp => vp.id === product.id)
                                );

                                handleSelectAll([...selectedProductsData, ...filteredUnselectedVisibleProducts], true);


                              }} className='btn add'>Select All</button>
                                <button className=" btn border-0" onClick={() => setExpandProductRows(prev => !prev)}>
                                  <img
                                    src={window.getPublicUrl(`/assets/images/${expandProductRows ? 'up-double-arrow.svg' : 'down-double-arrow.svg'}`)}
                                    alt=""
                                  />
                                </button></>)
                              }
                            </div>
                            {selectedProductsData.length > 0 &&
                              <div className="header-second text-center justify-content-center">

                                <p className="selected-product mb-0">Selected Product</p>
                                {/* {selectedProductsData.length > 0 && */}
                                <>
                                  <button type='button' onClick={() => {
                                    setSelectedProductsData([]);
                                    setProductIds([]);
                                    // setSearchValue('');
                                    setSelectAll(false)
                                    setExcludedProductIds([])
                                    setCurrentPage(1);

                                  }} className='btn add' disabled={selectedProductsData.length === 0}>Clear All</button>
                                </>
                                {/* } */}
                              </div>
                            }
                          </div>
                        </div>
                        <div className={`table-right ${expandProductRows ? 'expanded-product-rows' : ''}`}>
                          <div className="header-main">
                            <div className={`header ${expandProductRows ? 'expanded-product-rows' : ''}`} onScroll={handleScrollToBottom}>
                              {/* <div
    className="product-scroll-container"
    onScroll={handleScrollToBottom}
    style={{ maxHeight: 200, overflowY: "auto" }}
  > */}
                              {(() => {
                                // const visibleProducts = productData || [];
                                // const visibleProduct = selectedProductsData || [];

                                // Filter out products from visibleProducts that already exist in visibleProduct
                                const filteredUnselectedVisibleProducts = productData.filter(
                                  product => !selectedProductsData.some(vp => vp.id === product.id)
                                );

                                const hasProducts = filteredUnselectedVisibleProducts.length > 0;
                                const hasSelectedProducts = selectedProductsData.length > 0;
                                const hasMoreProducts = productData.length >= perPageSearch;
                                return (
                                  <>
                                    {/* {hasSelectedProducts  && (
                                // {hasSelectedProducts && visibleProducts?.length > 0 && (
                                  <div className={`${expandProductRows?'dropdown-scroll':'d-flex gap-2'}`}>
                                    {selectedProductsData.map((x) => (
                                      <h6
                                        key={x.id}
                                        onClick={() => handleProductId(x)}
                                        className={[
                                          productIds.some(selId => String(x.id) === String(selId)) ? "product-add active" : "",
                                          x.has_activity ? "has-activity" : ""
                                        ].join(" ").trim()}
                                      >
                                        {x?.name_tc}
                                      </h6>
                                    ))}
                                  </div>
                                )} */}

                                    {(hasProducts || hasSelectedProducts) && (
                                      <div className={`${expandProductRows ? 'dropdown-scroll' : 'd-flex gap-2'}`}>
                                        {hasSelectedProducts && selectedProductsData.map((x) => (
                                          <h6
                                            key={x.id}
                                            onClick={() => handleProductId(x)}
                                            className={[
                                              productIds.some(selId => String(x.id) === String(selId)) ? "product-add active" : "",
                                              x.has_activity ? "has-activity" : ""
                                            ].join(" ").trim()}
                                          >
                                            {x?.name_tc}
                                          </h6>
                                        ))}
                                        {hasProducts && filteredUnselectedVisibleProducts.map((x) => (
                                          <h6
                                            key={x.id}
                                            onClick={() => handleProductId(x)}
                                            className={[
                                              productIds.some(selId => String(x.id) === String(selId)) ? "product-add active" : "",
                                              x.has_activity ? "has-activity" : ""
                                            ].join(" ").trim()}
                                          >
                                            {x?.name_tc}
                                          </h6>
                                        ))}
                                        {/* {productIds.length > 10 && (
                                      <div className="">
                                        <button
                                          key="more-btn"
                                          onClick={() => setPerPageSearch(perPageSearch + 10)}
                                          className="bg-transparent border-0"
                                        >
                                          <img
                                            src={window.getPublicUrl("/assets/images/right-more.svg")}
                                            alt="Search"
                                          />
                                        </button>
                                      </div>
                                    )} */}
                                      </div>
                                    )}

                                    {productData?.length == 0 && !hasProducts && !hasSelectedProducts && (
                                      <div style={{ color: "#888", fontSize: 14, marginTop: 8 }}>
                                        No products found.
                                      </div>
                                    )}
                                    {/* {hasMoreProducts && hasProducts && (
                                  <div className="">
                                    <button
                                      key="more-btn"
                                      onClick={() => setPerPageSearch(perPageSearch + 10)}
                                      className="bg-transparent border-0"
                                    >
                                      <img
                                        src={window.getPublicUrl("/assets/images/right-more.svg")}
                                        alt="Search"
                                      />
                                    </button>
                                  </div>
                                )} */}
                                  </>
                                );
                              })()}
                            </div>

                            {/* </div> */}
                            <div class="header-second">
                              {selectedProductsData.length > 0 &&
                                selectedProductsData.map((x) => {
                                  return (
                                    <div key={x.id} className="">
                                      <h6>Product Code {x?.code} </h6>
                                      <h6>Product Name : {x?.name_tc} </h6>
                                      <h6>Specification : {x?.specification}</h6>
                                    </div>
                                  );
                                })}
                            </div>
                            {productLoader && <div className='loader-div'>

                              <span class="loader spniner-table"></span>

                            </div>}
                          </div>
                          {/* {!productLoader && 
                      <span class="loader spniner-table"></span>
                          } */}
                        </div>
                      </>
                    }
                  </div>

                  {/* <div className={`scroll-wrapper-inout  ${(Object.keys(inoutData).length > 0 ) ? '' : productIds?.length>0? 'no-data-found': (productIds?.length<=0 )?'no-data-show': isDeepEmpty(inoutData)? 'no-data' :''}`} onScroll={handleScroll} > */}
                  <div
                    className={`scroll-wrapper-inout ${Object.keys(inoutData).length > 0
                      ? ''
                      : productIds?.length > 0
                        ? 'no-data-found'
                        : (productIds?.length <= 0 && productData?.length === 0)
                          ? 'no-data-show'
                          : isDeepEmpty(inoutData)
                            ? 'no-data'
                            : ''
                      } ${expandProductRows ? 'onbtn-table-scroll' : ''}`}
                    onScroll={handleScroll} ref={tableContainerRef}
                  >

                    <div
                      class={`scroll-container inout-main-table ${(isDeepEmpty(inoutData) && productIds?.length > 0) ? 'no-table-data' : ''} ${loader ? "spinner-table" : ""
                        } ${scrolled ? "scrolled" : ""} ${loader ? 'on-loding-show-data' : ''}`}
                    >
                      {productIds?.length > 0 ?
                        <>
                          {tableLoader ? (
                            <div className="spinner-border spinner-border-sm" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          ) : (
                            <>

                              {/* // GenerateTable() */}
                              <MemoizedGenerateTable arrivalsData={''} dateState={dateState}
                                currentPage={currentPage}
                                inoutData={inoutData}
                                setInoutData={setInoutData}
                                setModalReserve={setModalReserve}
                                setReserveModalUpdateData={setReserveModalUpdateData}
                                showGroupData={showGroupData}
                                setshowGroupData={setshowGroupData}
                                setSelectedGroupProducts={setSelectedGroupProducts}
                                setArrivalModalData={setArrivalModalData}
                                tableRef={tableRef}
                                setShowAllArrivals={setShowAllArrivals}
                                showAllArrivals={showAllArrivals}
                                selectedGroupProducts={selectedGroupProducts}
                                setArrivalModalShow={setArrivalModalShow}
                                isEditing={isEditing}
                                updateId={updateId}
                                updateDate={updateDate}
                                updateProduct={updateProduct}
                                updateValue={updateValue}
                                setIsEditing={setIsEditing}
                                setUpdateValue={setUpdateValue}
                                setUpdateId={setUpdateId}
                                setUpdateDate={setUpdateDate}
                                setUpdateProduct={setUpdateProduct}
                                updateReserveData={debouncedUpdateReserveData}
                                arrivalModalShow={arrivalModalShow}
                                setSelectedArrivalProductId={setSelectedArrivalProductId}
                                setArrivalQuantityMap={setArrivalQuantityMap}
                                arrivalModalData={arrivalModalData}
                                selectedArrivalProductId={selectedArrivalProductId}
                                setSelectedArrivalProductData={setSelectedArrivalProductData}
                                setArrivalModalError={setArrivalModalError}
                                arrivalQuantityMap={arrivalQuantityMap}
                                arrivalModalError={arrivalModalError}
                                arrivalModalLoading={arrivalModalLoading}
                                handleSaveArrivalData={handleSaveArrivalData}
                                modalReserve={modalReserve}
                                modalRef={modalRef}
                                setReserveModalError={setReserveModalError}
                                reserveModalUpdateData={reserveModalUpdateData}
                                selectedProductId={selectedProductId}
                                setSelectedProductId={setSelectedProductId}
                                setQuantityValue={setQuantityValue}
                                quantityValue={quantityValue}
                                reserveModalError={reserveModalError}
                                toastMessage={toastMessage}
                                setProductLabelModal={setProductLabelModal}
                                addColumnModal={addColumnModal}
                                setAddColumnModal={setAddColumnModal}
                                productLabelModal={productLabelModal}
                                setLabelData={setLabelData}
                                labelData={labelData}
                                setSubGroup={setSubGroup}
                                setSubGroupName={setSubGroupName}
                                subGroup={subGroup}
                                subGroupName={subGroupName}
                                setGroupName={setGroupName}
                                groupName={groupName}
                                setProductName={setProductName}
                                productName={productName}
                                setLabelDate={setLabelDate}
                                labelDate={labelDate}
                                loader={loader}
                                setProductGroupLabelModal={setProductGroupLabelModal}
                                productGroupLabelModal={productGroupLabelModal}
                                // setModalType={setModalType}
                                // modalType={modalType}
                                groupRef={groupRef}
                                firstRadioRefProductLabel={firstRadioRefProductLabel}
                                firstRadioArrivalRef={firstRadioArrivalRef}
                                quatityRef={quatityRef}
                                setGroupProductIds={setGroupProductIds}
                                labels={labels}
                                customerSubGroups={customerSubGroups}
                                fetchLableCustomerGroups={fetchLableCustomerGroups}
                                labelCustomerGroups={labelCustomerGroups}
                                getInOutDataForReserveUpdate={getInOutDataForReserveUpdate}
                                updateArrivalOrderRemarkOnDrop={updateArrivalOrderRemarkOnDrop}
                                selectedCellsForSum={selectedCellsForSum}
                                setSelectedCellsForSum={setSelectedCellsForSum}
                                inputValues={inputValues}
                                convertOutInputs={convertOutInputs}
                                setConvertOutInputs={setConvertOutInputs}
                                setModalConvertOut={setModalConvertOut}
                                modalConvertOut={modalConvertOut}
                                debouncedUpdateConvertOutData={debouncedUpdateConvertOutData}
                                handleInlineAddReserve={handleInlineAddReserve}
                                handleInlineAddArrival={handleInlineAddArrival}
                                getArrivalsData={getArrivalsData}
                              />
                              {/* {isDeepEmpty(inoutData) && <p className='no-dtata-records'>No data found for select filter </p>} */}
                              {pinkSectionLoading && <div className='horizontal-loader'>
                                <div className="spinner-border spinner-border-lg" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </div>}
                            </>
                          )}
                        </>
                        :
                        <div className='no-dtata-records'>{(searchValue !== '' || selectedCategoryIds?.length > 0 || selectedOriginIds?.length > 0 || selectedBrandName?.length > 0 || selectedPicImport?.length > 0 || selectedPicSales?.length > 0 || selectedProductGroupVarietyIds?.length > 0) ? productData?.length === 0 ? (productLoader ? 'Loading...' : 'No product found for this filter') : 'Please select products to view the data' : 'Please select filter to view the product'}</div>
                      }
                    </div>
                  </div>
                </div>

              </div>
              {/* {toastMessage && <p>Please wait....</p>} */}
              {loader && (
                <div style={{
                  position: 'fixed',
                  inset: '341px',
                  zIndex: 9999,
                  margin: '0 auto',
                  textAlign: 'center',
                  width: '85%',
                  justifyContent: 'center',
                }}>
                  <div className="spinner-border spinner-border-lg" role="status">
                    <span className="visually-hidden">Loading...</span>

                  </div>
                  <p className='d-block uploading-data-text'>Updating please wait....</p>
                </div>
              )}
              <div class="table-footer d-flex justify-content-between table-pagination">
                <div className=''>
                  <p className='show-records mb-0'>
                    {(productIds?.length > 0) &&
                      `Showing {
                      ${Math.min((currentPage - 1) * itemsPerPage + 1, allDatess?.length || 0)} to ${Math.min(currentPage * itemsPerPage, allDatess?.length || 0)}
                    } of ${allDatess?.length || 0} entries`
                    }
                  </p>
                </div>
                {(productIds?.length > 0) && <div className="status-bar">
                  {Object.keys(selectedCellsForSum).length > 0 && (
                    <>
                      <span>Sum: {Object.values(selectedCellsForSum).reduce((a, b) => a + b, 0)}</span>{" "}
                      <span>Count: {Object.values(selectedCellsForSum).length}</span>
                    </>
                  )

                  }
                </div>}
                <div className=''>
                  {(productIds?.length > 0) &&
                    <TableFooter
                      pageCount={totalPage}
                      handlePageClick={handlePageClick}
                      currentPage={currentPage}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      {/* Inline Add Reserve Modal */}
      <Modal
        open={inlineReserveModal}
        onCancel={() => setInlineReserveModal(false)}
        footer={null}
        width={1100}
        title="Add Reserve"
        destroyOnClose
        style={{ top: 20 }}
      >
        {inlineReserveModal && (
          <AddEditReserve
            toggleAddReserve={() => setInlineReserveModal(false)}
            customerGroupData={reserveCustomerGroupData}
            customerSubGroupData={reserveCustomerSubGroupData}
            getReserveData={() => {}}
            prefillDateRange={inlineReservePrefill.dateRange}
            prefillProductId={inlineReservePrefill.productId}
            prefillProductName={inlineReservePrefill.productName}
            prefillProductCode={inlineReservePrefill.productCode}
            onSaved={() => {
              setInlineReserveModal(false);
              setGroupProductIds(inlineReservePrefill.refreshIds);
              // getInOutDataForReserveUpdate(inlineReservePrefill.refreshIds);
              getArrivalsData();
            }}
          />
        )}
      </Modal>
      <Modal
        open={inlineArrivalModal}
        onCancel={() => {
          setInlineArrivalModal(false);
          arrivalResetForm();
        }}
        footer={null}
        width={1100}
        title="Add Arrival"
        destroyOnClose
        style={{ top: 20 }}
      >
        {inlineArrivalModal && (
          <div className="modal-add-edit-arrival">
            <AddEditArrival
              setMethodType={() => { setInlineArrivalModal(false); arrivalResetForm(); }}
              resetForm={arrivalResetForm}
              touched={arrivalTouched}
              errors={arrivalErrors}
              formData={arrivalFormData}
              handleInputChange={arrivalHandleInputChange}
              handleBlur={arrivalHandleBlur}
              suppliers={arrivalSuppliers}
              shippingMethods={arrivalShippingMethods}
              handleDateChange={arrivalHandleDateChange}
              searchTerm={arrivalSearchTerm}
              setIsDropdownOpen={() => {}}
              isDropdownOpen={false}
              filteredProducts={[]}
              selectedProducts={[]}
              setSearchTerm={setArrivalSearchTerm}
              handleProductClick={() => {}}
              setShowAddProductModal={() => {}}
              setProductSearchQuery={() => {}}
              setAvailableProducts={() => {}}
              setSelectedProducts={() => {}}
              fetchAvailableProducts={() => {}}
              toggleAllProductsCheckbox={arrivalToggleAllProductsCheckbox}
              products={[]}
              toggleProductCheckbox={arrivalToggleProductCheckbox}
              handleProductChange={arrivalHandleProductChange}
              removeProduct={arrivalRemoveProduct}
              handleAddArrival={handleInlineAddArrivalSubmit}
              isLoading={arrivalIsLoading}
              type="add"
              arrivalToEdit={null}
              selectedShowProducts={arrivalSelectedShowProducts}
              resetFormArrival={arrivalResetFormArrival}
              setFilterData={setArrivalFilterDatas}
              filterDatas={arrivalFilterDatas}
              productlist={arrivalProductList}
              setProductList={setArrivalProductList}
              setSelectedShowProducts={setArrivalSelectedShowProducts}
              isModal={true}
            />
          </div>
        )}
      </Modal>
    </>
  )
}

export default React.memo(PrepackInout)